<template>
  <Component
    :is="to ? 'RouterLink' : 'button'"
    :to="to"
    :type="type"
    class="bg-primary text-primary-fg relative block flex items-center justify-center overflow-hidden px-3 py-2 font-medium disabled:opacity-40"
    :class="brandButtonClass"
  >
    <slot />
    <template v-if="isLoading">
      <BaseInnerLoading />
    </template>
  </Component>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"
const props = withDefaults(
  defineProps<{
    isLoading?: boolean
    to?: RouteLocationRaw
    type?: string
  }>(),
  {
    isLoading: false,
    to: undefined,
    type: "button",
  }
)

const brandButtonClass =
  import.meta.env.VITE_ORGANIZATION === "boipa"
    ? "rounded-tl-3xl rounded-br-3xl"
    : "rounded-lg"
</script>
